import { render, staticRenderFns } from "./NewArticleCardAd.vue?vue&type=template&id=6b8b5f32&"
import script from "./NewArticleCardAd.vue?vue&type=script&lang=js&"
export * from "./NewArticleCardAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports